import { atom } from "recoil";

export const AdminMenus = atom({
  key: "AdminMenus",
  default: {type:"",item:""}
});

export const ParentsMenus = atom({
  key: "ParentsMenus",
  default: {showMenu:false,gotoMain:0}
})

export const BranchMenus = atom({
  key: "BranchMenus",
  default: {showMenu:false,gotoMain:0}
})